/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
    'use strict';

    /**
     * Вид для формы самовывоза
     */
    app.JointPurchaseDeliveryPickupFormView = app.JointPurchaseDeliveryFormView.extend({
        el: '',

        templateName: '#template-delivery-pickup-form'
    });
})(jQuery);

}.call(window));